import React, { useState, useEffect } from 'react';
import ConfirmDialog from './ConfirmDialog';
import logger from '../utils/logger';

let confirmListener = null;
let confirmResolvers = {};

export const ConfirmContainer = () => {
  const [confirms, setConfirms] = useState([]);

  useEffect(() => {
    confirmListener = (confirm) => {
      setConfirms(prev => [...prev, confirm]);
    };

    return () => {
      confirmListener = null;
      confirmResolvers = {};
    };
  }, []);

  const handleClose = (id, result) => {
    // Résoudre la promesse
    if (confirmResolvers[id]) {
      confirmResolvers[id](result);
      delete confirmResolvers[id];
    }

    // Retirer le confirm
    setConfirms(prev => prev.filter(c => c.id !== id));
  };

  return (
    <>
      {confirms.map(confirm => (
        <ConfirmDialog
          key={confirm.id}
          confirm={confirm}
          onClose={handleClose}
        />
      ))}
    </>
  );
};

// Service de confirmations - retourne une promesse
let confirmId = 0;

export const confirmDialog = (options) => {
  return new Promise((resolve) => {
    if (!confirmListener) {
      logger.error('ConfirmContainer not mounted');
      resolve(false);
      return;
    }

    const id = confirmId++;
    const confirm = {
      id,
      title: options.title,
      message: options.message,
      type: options.type || 'default', // 'danger', 'warning', 'info', 'default'
      confirmText: options.confirmText || 'Confirmer',
      cancelText: options.cancelText || 'Annuler'
    };

    confirmResolvers[id] = resolve;
    confirmListener(confirm);
  });
};

// Helper functions pour des cas d'usage courants
export const confirm = {
  // Confirmation simple
  ask: (message, title = 'Confirmation') => {
    return confirmDialog({
      title,
      message,
      type: 'default'
    });
  },

  // Confirmation de suppression (danger)
  delete: (message, title = 'Confirmer la suppression') => {
    return confirmDialog({
      title,
      message,
      type: 'danger',
      confirmText: 'Supprimer',
      cancelText: 'Annuler'
    });
  },

  // Confirmation de danger
  danger: (message, title = 'Attention') => {
    return confirmDialog({
      title,
      message,
      type: 'danger',
      confirmText: 'Confirmer',
      cancelText: 'Annuler'
    });
  },

  // Confirmation d'avertissement
  warning: (message, title = 'Avertissement') => {
    return confirmDialog({
      title,
      message,
      type: 'warning',
      confirmText: 'Continuer',
      cancelText: 'Annuler'
    });
  },

  // Confirmation d'information
  info: (message, title = 'Information') => {
    return confirmDialog({
      title,
      message,
      type: 'info',
      confirmText: 'OK',
      cancelText: 'Annuler'
    });
  },

  // Confirmation personnalisée
  custom: (options) => {
    return confirmDialog(options);
  }
};

export default ConfirmContainer;
